import { Window as WindowType } from 'types/window';

declare const window: Window & WindowType;

export const isMobile = (): boolean => window.innerWidth <= 480;
const isUsingAndroidApp = (): boolean => /LiveChat_Android_App/i.test(navigator.userAgent);
const isUsingIOSApp = (): boolean => window?.webkit?.messageHandlers?.ios;
export const getMobileOS = (): string => (isUsingIOSApp() ? 'ios' : 'android');
export const isUsingMobileApp = (): boolean => isUsingAndroidApp() || isUsingIOSApp();
